import React from "react";
import CourseLayOut from "./course-layout";

function HistoryCourse() {
    return <div className='history'>
        <p className="date">2020-8-20</p>
        <CourseLayOut
            list={[]}
            render={() => <div className="status mine">
                <div className="l">
                    <p className="iconfont">&#xe671;</p>
                    <p>继续观看</p>
                </div>
                <div className="r">
                    <p className="sell">
                        共30节课程
                    </p>
                </div>
            </div>}/>
        <p className="date">2020-8-12</p>
        <CourseLayOut
            list={[]}
            render={() => <div className="status mine">
                <div className="l">
                    <p className="iconfont">&#xe671;</p>
                    <p>继续观看</p>
                </div>
                <div className="r">
                    <p className="sell">
                        共30节课程
                    </p>
                </div>
            </div>}/>
    </div>
}

export default HistoryCourse;
